import { isNullOrUndefined } from '../../../shared/utils/is-null-or-undefined';

export function clone(obj: any): any {
  if (isNullOrUndefined(obj)) {
    return null;
  } else {
    return JSON.parse(JSON.stringify(obj));
  }
}
